import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { hasPath, path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';

const FullnameInputs = () => {
	const {
		control,
		formState: { errors }
	} = useFormContext();
	return (
		<>
			<Grid item xs={12} sm={6}>
				<Controller
					name="first_name"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							autoFocus
							{...field}
							variant="outlined"
							label="First Name"
							helperText={path(['first_name', 'message'], errors)}
							error={hasPath(['first_name', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Controller
					name="last_name"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="Last Name"
							helperText={path(['last_name', 'message'], errors)}
							error={hasPath(['last_name', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
		</>
	);
};

export default FullnameInputs;
